import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Laura', 'José', 'Ana', 'Pedro', 'Carmen', 'Luis', 'Isabel', 'Diego'];
const CITIES = ['Buenos Aires', 'Madrid', 'Barcelona', 'México DF', 'Bogotá', 'Lima', 'Santiago', 'Montevideo', 'Valencia', 'Sevilla'];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 8000);
    // Recurring interval (random between 8-15s + 5s display time)
    const interval = setInterval(() => {
      if (!visible) {
        const randomDelay = Math.floor(Math.random() * 7000) + 8000; // 8-15 seconds
        setTimeout(showPopup, randomDelay);
      }
    }, 20000); // Check every 20s to be safe
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 right-4 z-50 animate-slide-in-right" data-id="element-18">
      <div className="bg-white rounded-lg shadow-xl p-4 flex items-center gap-3 border-l-4 border-green-500 max-w-sm" data-id="element-19">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-20">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-21" />
        </div>
        <div data-id="element-22">
          <p className="text-sm font-medium text-gray-900" data-id="element-23">
            <span className="font-bold" data-id="element-24">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-25">acaba de comprar este kit</p>
        </div>
      </div>
    </div>;
}